module.exports = __webpack_public_path__ + "img/38.51d84138.png";